<template>
  <div>
    <div
      v-if="contactFormBlockTime"
      ref="contactFormBlockTimeMessage"
      :class="$style.remainingBlockTimeMessage"
    >
      <i18n-t keypath="contactForm.remainingBlockTimeMessage.statement" tag="div" scope="global">
        <template #remainingBlockTime>
          <span>{{ contactFormBlockTime }}</span>
        </template>
        <template #serviceName>
          <HgLink
            ref="learnMoreCta"
            :href="tenantPlusLandingPageUrl"
            target="_blank"
            @click="trackLearnMoreCta"
          >
            {{ t('contactForm.remainingBlockTimeMessage.tenantPlusServiceName') }}
          </HgLink>
        </template>
      </i18n-t>
    </div>
    <div v-else ref="contactFormBlockTimeMessage" :class="$style.remainingBlockTimeMessage">
      <i18n-t
        keypath="contactForm.remainingBlockTimeMessage.statmentWithNoBlockingTime"
        tag="div"
        scope="global"
      >
        <template #serviceName>
          <HgLink
            ref="learnMoreCta"
            :href="tenantPlusLandingPageUrl"
            target="_blank"
            @click="trackLearnMoreCta"
          >
            {{ t('contactForm.remainingBlockTimeMessage.tenantPlusServiceName') }}
          </HgLink>
        </template>
      </i18n-t>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { HgLink } from '@smg-real-estate/domus';
import { computed } from 'vue';

import { InteractionEvent } from '@/helpers/GTM/GTMParameters';
import { trackEventHarmonized } from '@/helpers/GTM/GTMTrack';
import { generateTenantPlusLandingPageUrl } from '@/helpers/TenantPlus/TenantPlusUrls';
import { useI18n } from 'vue-i18n';

defineOptions({
  name: 'ContactBlockingTime',
});

interface Props {
  contactFormBlockTime: string;
  entryPoint: string;
}
const props = defineProps<Props>();

const { t, locale } = useI18n();

const tenantPlusLandingPageUrl = computed((): string => {
  return generateTenantPlusLandingPageUrl(locale.value, props.entryPoint);
});

const trackLearnMoreCta = (): void => {
  const trackingParams: Record<string, any> = {
    h_event_category_006: InteractionEvent.PDP_INTERACTION,
    h_event_action_007: 'goTo_tplusLandingPage',
    h_event_label_008: 'countdown_link',
  };
  if (props.entryPoint !== undefined) {
    trackingParams.h_funnel_step_input_141 = `${props.entryPoint}_countdown_link`;
  }
  trackEventHarmonized(InteractionEvent.PDP_INTERACTION, trackingParams);
};
</script>

<style lang="scss" module>
@import '@/assets/variables';

.remainingBlockTimeMessage {
  padding-top: $space-75;

  span {
    @include font-bold;
  }
}
</style>
